var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircleFill = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699C14.6036 1.66699 18.3346 5.39795 18.3346 10.0003C18.3346 14.6027 14.6036 18.3337 10.0013 18.3337ZM10.0013 8.82183L7.64428 6.46479L6.46577 7.6433L8.8228 10.0003L6.46577 12.3573L7.64428 13.5358L10.0013 11.1788L12.3583 13.5358L13.5368 12.3573L11.1798 10.0003L13.5368 7.6433L12.3583 6.46479L10.0013 8.82183Z",
  fill: "#E36D32"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleFill);
export { ForwardRef as ReactComponent };